export default {
  lang: { fr: "Français", en: "English", it: "Italiano", ar: "العربية" },
  common: {
    loading: "جارٍ التحميل…",
    size: "المقاس",
    sizeX: "المقاس {{size}} × {{n}}",
    subtotal: "المجموع الفرعي",
    delivery: "التوصيل",
    free: "مجانًا",
    total: "الإجمالي",
    backToShop: "العودة إلى المتجر",
    discoverShop: "اكتشف المتجر",
    added: "أُضيف {{name}} إلى السلة",
    quickAdd: "إضافة سريعة",
    pieces1: "قطعة واحدة",
    piecesN: "{{n}} قطع",
  },
  sizes: { custom: "حسب الطلب", onesize: "مقاس واحد", years: "{{n}} سنوات" },
  nav: { man: "رجال", woman: "نساء", couple: "أطقم للأزواج", kids: "الأطفال", leather: "الجلود", essayage: "القياس الافتراضي", maison: "الدار", surmesure: "تفصيل خاص" },
  tryon: {
    eyebrow: "تجربة B.KOSS",
    titlePre: "القياس",
    titleIt: "الافتراضي",
    intro: "ركّب طقمك، ارفع صورتك، وسيُلبسك ذكاؤنا الاصطناعي بثلاث مشاهد — أمامية وجانبية وخلفية — قبل أن تطلب حتى.",
    step1: "الخطوة ٠١",
    tenueTitle: "طقمك",
    emptyTenue: "لم يتم اختيار أي قطعة — تصفح الكتالوج أدناه أو استخدم زر « قياس » على القطع.",
    all: "الكل",
    maxPieces: "حتى ٤ قطع لكل طقم",
    clear: "إزالة الكل",
    step2: "الخطوة ٠٢",
    photoTitle: "صورتك",
    tip1: "صورة أمامية بجسم كامل ظاهر",
    tip2: "إضاءة جيدة، ويُفضل الضوء الطبيعي",
    tip3: "ملابس محايدة وخلفية بسيطة",
    upload: "ارفع صورتي",
    retake: "تغيير الصورة",
    photoOk: "تم استلام الصورة",
    errPhoto: "صورة غير صالحة — التقط صورة أمامية جيدة الإضاءة (JPG/PNG، بحد أقصى 10 ميغابايت)",
    consent: "أوافق على استخدام صورتي فقط لإنشاء هذا القياس الافتراضي، ثم حذفها تلقائيًا خلال 24 ساعة.",
    needConsent: "يرجى الموافقة على استخدام صورتك للمتابعة",
    generate: "أنشئ قياسي الافتراضي",
    generating: "مشاغلنا الرقمية تلبس سيلويتك…",
    progress: "تم إعداد {{n}}/3 من المشاهد",
    viewHint: "اسحب للدوران 360°",
    resultEyebrow: "قياسك الافتراضي",
    resultTitle: "الطقم يناسبك",
    download: "تنزيل",
    share: "مشاركة",
    shareText: "قياسي الافتراضي B.KOSS — علامة الرجال العظماء",
    addToCart: "أضف الطقم إلى السلة",
    addedCart: "تمت إضافة الطقم إلى السلة",
    modify: "تعديل الاختيار",
    report: "الإبلاغ عن مشكلة",
    errDaily: "لقد استخدمت قياساتك المجانية لهذا اليوم — احجز موعدًا في المشغل لقياس خاص",
    errGeneric: "لا يمكن الإنشاء — تحقق من صورتك (أمامية، جيدة الإضاءة) وحاول مجددًا",
    tried: "تمت إضافة {{name}} إلى قياسك",
    footerNote: "كل قياس افتراضي هو تفسير رقمي — لقياس خاص مع خبراء الخياطة لدينا، احجز موعدًا في المشغل.",
    shopCta: "زيارة المتجر",
    videoButton: "فيلم 360°",
    videoBusy: "استوديونا يصوّر سيلويتك…",
    videoHint: "فيلم مُنشأ بالذكاء الاصطناعي — يستغرق 2 إلى 4 دقائق",
    videoError: "تعذّر إنشاء الفيلم — حاول مجددًا",
    backToViews: "العودة إلى الصور",
  },
  header: {
    slogan: "علامة الرجال العظماء",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    openCart: "فتح السلة",
    city: "أبيدجان — ساحل العاج",
    lang: "اللغة",
  },
  footer: {
    description: "دار خياطة وُلدت في أبيدجان. أزياء جاهزة استثنائية وتفصيل خاص وإكسسوارات تُصنع لمن يتركون بصمتهم على عصرهم.",
    emailPh: "بريدك الإلكتروني",
    join: "انضم",
    circle: "دائرة B.KOSS — مجموعاتنا قبل غيركم",
    shopCol: "المتجر",
    catCouple: "أطقم للأزواج",
    catLeather: "الجلود والإكسسوارات",
    allPieces: "جميع القطع",
    presse: "الصحافة والمعارض",
    maisonCol: "الدار",
    addr1: "ريفيرا جاردن، مقابل المدرسة ليس جاسمين",
    addr2: "كوكودي — أبيدجان، ساحل العاج",
    rights: "جميع الحقوق محفوظة",
    nlOk: "تم تأكيد الاشتراك",
    nlOkDesc: "ستصلك مجموعاتنا قبل غيركم.",
    nlErr: "تعذر الاشتراك — تحقق من عنوانك.",
  },
  marquee: { m1: "علامة الرجال العظماء", m2: "أبيدجان", m3: "خياطة راقية", m4: "تفصيل خاص", m5: "ساحل العاج", m6: "من الورشة" },
  home: {
    heroEyebrow: "دار خياطة — أبيدجان، ساحل العاج",
    t1: "علامة",
    t2pre: "",
    t2it: "الرجال",
    t3: "العظماء",
    heroText: "خياطة استثنائية تُصنع في أبيدجان. أزياء جاهزة وتفصيل خاص وإكسسوارات لمن يتركون أثرًا خلفهم عند مرورهم.",
    ctaCollection: "اكتشف المجموعة",
    ctaSurmesure: "التفصيل الخاص",
    scroll: "مرّر للأسفل",
    videoCard: "إبورني — الطقم المميز",
    soundOn: "تشغيل صوت الفيلم",
    soundOff: "كتم صوت الفيلم",
    colEyebrow: "المجموعات",
    colPre: "اختر",
    colIt: "فئتك",
    viewAll: "جميع القطع",
    bentoManSub: "{{n}} قطع — قمصان وبولو وتونيك وسروالات",
    bentoWomanSub: "{{n}} قطع — أنياقة ملكية",
    bentoCoupleSub: "{{n}} قطع — تناغم متطابق",
    bentoKidsSub: "{{n}} قطع — عظماء الغد",
    bentoLeatherSub: "{{n}} قطع — التفصيلة التي توقّع",
    atelierEyebrow: "الورشة",
    atelierTitle: "التفصيل الخاص",
    atelierText: "قطعة تُفصَّل لك وحدك، على أيدي أساتذة خياطينا في أبيدجان.",
    bookRdv: "احجز موعدًا",
    spotEyebrow: "قطعة الشهر",
    viewPiece: "اعرض القطعة",
    maisonEyebrow: "الدار",
    maisonPre: "وُلدت في أبيدجان،",
    maisonIt: "والعالم يحتضنها",
    maisonText: "من كوكودي إلى المعارض الدولية، تحمل B.KOSS خياطة ساحل العاج إلى حيث لم يُنتظرها. العلامة الإفريقية الوحيدة في الدورة الـ98 من معرض الجلود الدولي EXPORIVASCHUH GADABAGS في إيطاليا 2023، وضيفة معرض NY NOW في نيويورك العام نفسه — الدار تكتب الفخامة بعلاماتها الخاصة.",
    c1Sub: "الدار الأم",
    c2Sub: "EXPORIVASCHUH 2023",
    c3Sub: "NY NOW 2023",
    maisonCta: "اكتشف الدار",
    bandEyebrow: "بموعد مسبق",
    bandPre: "قوامك،",
    bandIt: "مفصَّل ليبقى",
    bandCta: "احجز موعدًا",
    newsEyebrow: "وصل حديثًا",
    newsPre: "أحدث",
    newsIt: "القطع",
  },
  boutique: {
    eyebrow: "المتجر",
    allPre: "جميع",
    allPost: "القطع",
    allTitle: "جميع القطع",
    filterAll: "الكل",
    sortNew: "وصل حديثًا",
    sortAsc: "السعر تصاعديًا",
    sortDesc: "السعر تنازليًا",
    families: "العائلات:",
    empty: "لا توجد قطع في هذه الفئة حاليًا.",
  },
  product: {
    notFound: "هذه القطعة غير موجودة.",
    backLink: "المتجر",
    size: "المقاس",
    qtyMinus: "إنقاص الكمية",
    qtyPlus: "زيادة الكمية",
    addToCart: "أضف إلى السلة — {{price}}",
    info1: "توصيل سريع مجاني في أبيدجان (24–48 ساعة). شحن دولي متتبَّع.",
    info2: "دفع آمن عبر المحفوظة المحمولة — Wave وOrange وMTN وMoov.",
    info3: "تعديلات مجانية في المتجر. ضمان القَصّة مدى الحياة.",
    craft: "الحِرفة",
    craftText: "{{fabric}}. تخضع كل قطعة لأيدي أساتذة خياطينا في ورشة B.KOSS بريفيرا جاردن، كوكودي. تشطيبات يدوية وفحص لكل قطعة وشعار منسوج.",
    customAcc: "التفصيل الخاص",
    customText: "تتوفر هذه القطعة أيضًا بمقاساتك. احجز موعدًا مع الورشة: أخذ القياسات، اختيار الأقمشة، قياسان تجريبيان، والتسليم خلال ثلاثة أسابيع.",
  },
  cart: {
    title: "سلتك",
    empty: "سلتك فارغة.",
    checkout: "إتمام الطلب",
    momoNote: "المحفوظة المحمولة — Wave · Orange · MTN · Moov",
    remove: "إزالة {{name}}",
    decrease: "إنقاص",
    increase: "زيادة",
  },
  checkout: {
    eyebrow: "الإتمام",
    pre: "تأكيد",
    it: "طلبك",
    s1: "I. بياناتك",
    fullName: "الاسم الكامل",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    country: "البلد",
    city: "المدينة",
    address: "عنوان التوصيل",
    note: "ملاحظة للورشة (اختياري)",
    phName: "كوفي أجامي",
    phEmail: "you@example.com",
    phPhone: "+225 07 00 00 02 12",
    phCity: "أبيدجان",
    phAddress: "ريفيرا جاردن، كوكودي…",
    phMomo: "07 00 00 02 12",
    countryCi: "ساحل العاج",
    countryFr: "فرنسا",
    countryUs: "الولايات المتحدة",
    countryOther: "أخرى",
    s2: "II. الدفع",
    momoTitle: "المحفوظة المحمولة",
    momoVia: "— عبر NicePay",
    momoSub: "ستصلك طلب دفع على هاتفك؛ أكّده برمزك السري.",
    operator: "المشغّل",
    momoPhone: "رقم المحفوظة المحمولة",
    cardTitle: "بطاقة بنكية",
    cardVia: "— آمن عبر Stripe",
    cardSub: "فيزا، ماستركارد… تُحوَّل المبالغ من الفرنك بتعادل ثابت (1 € = 655.957 FCFA).",
    codTitle: "الدفع عند الاستلام",
    codSub: "ادفع ثمن طلبك عند استلامه، نقدًا أو عبر المحفوظة المحمولة.",
    recap: "الملخص",
    momoErr: "أدخل رقم المحفوظة المحمولة المطلوب خصمه.",
    orderErr: "تعذر تسجيل الطلب.",
    confirming: "جارٍ التأكيد…",
    submit: "تأكيد الطلب",
    secure: "دفع آمن — أصالة مضمونة",
  },
  confirmation: {
    paidTitle: "شكرًا.",
    pendingTitle: "تم تسجيل طلبك.",
    ref: "المرجع",
    simBadge: "وضع المحاكاة — عمليات الدفع الحقيقية عند تفعيل حساب التاجر NicePay",
    cardPending: "الدفع بالبطاقة في انتظار تأكيد Stripe — تُحدَّث هذه الصفحة تلقائيًا.",
    momoSim: "طلب دفع محاكى: ستصلك إشارة على هاتفك. أكّد برمزك السري.",
    validated: "لقد أكدت الدفع",
    payNow: "ادفع الآن — المحفوظة المحمولة",
    verifying: "جارٍ التحقق…",
    payOk: "تم تأكيد الدفع. شكرًا.",
    payPending: "الدفع لا يزال بانتظار التحقق.",
    payErr: "تعذر التحقق من الدفع.",
    notFound: "الطلب غير موجود.",
    deliveryNote: "توصيل سريع خلال 24–48 ساعة في أبيدجان",
    continue: "مواصلة التسوق",
  },
  maison: {
    heroEyebrow: "دار B.KOSS",
    heroPre: "إرث",
    heroIt: "أبيدجان",
    storyTitlePre: "الخياطة",
    storyTitleIt: "لغة أم",
    story1: "وُلدت B.KOSS في أبيدجان، بين صفوف أقمشة ورشة ريفيرا جاردن وناطحات سحاب البلاتو. الدار تلبس من يبنون ويقررون ويتألقون — الرجال العظماء والنساء العظماء في عصرهم.",
    story2: "معترف بها إلى ما وراء حدود ساحل العاج، كانت الدار العلامة الإفريقية الوحيدة في الدورة الـ98 من معرض الجلود الدولي EXPORIVASCHUH GADABAGS في إيطاليا 2023، قبل أن تُدعى إلى معرض NY NOW في نيويورك. ومع ذلك تبقى كل قطعة تُصنع هنا، في كوكودي، على أيدي أساتذة خياطينا.",
    quote: "«الفخامة ليست امتلاك كل شيء، بل أن تكون فريدًا.»",
    valEyebrow: "التزاماتنا",
    valPre: "اللمسة المثالية، بلا",
    valIt: "مصالحات",
    v1t: "التفصيل الخاص",
    v1d: "أخذ القياسات، اختيار الأقمشة، قياسان تجريبيان: قطعتك لا تنتمي إلا لك.",
    v2t: "تطريز يدوي",
    v2d: "زخارف باولي بخيوط ذهبية، تنفّذ بالإبرة على أيدي طرّازينا في كوكودي.",
    v3t: "أقمشة نبيلة",
    v3d: "صوف بارد وحرير دوقة وجلود كاملة الحبيبات — مختارة بلا مصالحة.",
    rdvEyebrow: "المواعيد",
    rdvPre: "احجز موعدك",
    rdvIt: "في الورشة",
    rdvText: "تفصيل خاص أو تعديلات أو استشارة صورة: نستقبلك في صالوننا الخاص بريفيرا جاردن، مقابل المدرسة ليس جاسمين، كوكودي — أبيدجان. مفتوح من الاثنين إلى السبت، 9ص–7م.",
    fName: "الاسم الكامل",
    fEmail: "البريد الإلكتروني",
    fPhone: "الهاتف",
    fService: "الخدمة",
    svc1: "تفصيل خاص",
    svc2: "تعديلات",
    svc3: "استشارة صورة",
    svc4: "المناسبات الكبرى",
    fDate: "التاريخ المفضل",
    fProject: "مشروعك (اختياري)",
    sending: "جارٍ الإرسال…",
    submit: "اطلب موعدي",
    ok: "تم إرسال الطلب — المرجع {{ref}}",
    okDesc: "ستتصل بك الورشة خلال 24 ساعة للتأكيد.",
    err: "تعذر الإرسال — تحقق من معلوماتك.",
  },
  presse: {
    eyebrow: "الصحافة والمعارض",
    pre: "الدار",
    it: "في الواجهة",
    intro: "وُلدت في أبيدجان، تحمل B.KOSS خياطة ساحل العاج إلى أعرق منصات الموضة والجلود دوليًا. موعدان كبيران طبعا عام 2023 للدار.",
    milanCity: "ميلان — إيطاليا",
    milanEdition: "الدورة 98 · يناير 2023",
    milanP1: "في يناير 2023، عبرت B.KOSS لأول مرة أبواب معرض دولي للجلود: الدورة الـ98 من EXPORIVASCHUH GADABAGS في إيطاليا. أولاً للدار — وأول للقارة: كانت B.KOSS العلامة الإفريقية الوحيدة الحاضرة.",
    milanP2: "عُرضت الحقائب والمحافظ وإكسسوارات السفر الجلدية الراقية على المشترين من العالم أجمع، إلى جانب دورات القطاع الكبرى.",
    milanQ1: "جذب جناحنا عددًا كبيرًا من الزوار المهتمين بقطعنا.",
    milanQ2: "أُعجب المشترون بجودة منتجاتنا والتزامنا بالمواد الراقية والحِرفة الاستثنائية.",
    nyCity: "نيويورك — الولايات المتحدة",
    nyEdition: "13 – 16 أغسطس 2023",
    nyP1: "بعد ستة أشهر، اتجهت الدار إلى نيويورك لمعرض NY NOW، أحد أبرز مواعيد الموضة والتصميم في الولايات المتحدة، من 13 إلى 16 أغسطس 2023.",
    nyP2: "عرضت B.KOSS موديلاتها المصبوغة بألوان إفريقية، حاملة التوقيع العاجي إلى قلب مانهاتن.",
    nyQ1: "كل هذا بفضل دعمكم. معًا، لنُظهر الموضة بشكل آخر ولنواجه تحديات أكبر.",
    quoteBy: "دار B.KOSS",
    nextPre: "الخطوة التالية:",
    nextIt: "خزانتك",
    cta: "اكتشف المجموعة",
  },
  errors: { boundary: "تم فك خيط ما.", back: "العودة إلى الرئيسية" },
};
